import API from "../libs/api";


class TallyService {
  // Get Tally Summary (Profit/Loss Dashboard)
  static async getTallySummary(schoolId, academicYearId) {
    try {
      const response = await API.get(
        `/api/admin/tally/summary/${schoolId}?yearId=${academicYearId}`
      );
      return response;
    } catch (error) {
      console.error('Error fetching tally summary:', error);
      throw error;
    }
  }

  // Get All Expenses for a school and academic year
  static async getExpenses(schoolId, academicYearId) {
    try {
      const response = await API.get(
        `/api/admin/tally/expenses/${schoolId}?yearId=${academicYearId}`
      );
      return response;
    } catch (error) {
      console.error('Error fetching expenses:', error);
      throw error;
    }
  }

  static async exportExpenses(schoolId, academicYearId) {
    const response = await API.get(
      `/api/admin/tally/expenses/export/${schoolId}?yearId=${academicYearId}`,
      { responseType: "blob" }
    );
    return response.data;
  }

  // Add New Expense
  static async addExpense(schoolId, academicYearId, expenseData) {
    try {
      const response = await API.post(
        `/api/admin/tally/add-expense/${schoolId}?yearId=${academicYearId}`,
        expenseData
      );
      return response;
    } catch (error) {
      console.error('Error adding expense:', error);
      throw error;
    }
  }

  static async getIncome(schoolId, academicYearId) {
    return API.get(
      `/api/admin/tally/income-records/${schoolId}?yearId=${academicYearId}`
    );
  }

  static async getIncomeSummary(schoolId, academicYearId) {
    return API.get(
      `/api/admin/tally/income/${schoolId}?yearId=${academicYearId}`
    );
  }

  static async getIncomeRecord(incomeId) {
    return API.get(`/api/admin/tally/income-record/${incomeId}`);
  }

  static async addIncome(schoolId, academicYearId, incomeData) {
    return API.post(
      `/api/admin/tally/income/${schoolId}?yearId=${academicYearId}`,
      incomeData
    );
  }

  static async updateIncome(incomeId, incomeData) {
    return API.put(`/api/admin/tally/income/${incomeId}`, incomeData);
  }

  static async deleteIncome(incomeId) {
    return API.delete(`/api/admin/tally/income/${incomeId}`);
  }

  static async exportIncome(schoolId, academicYearId) {
    const response = await API.get(
      `/api/admin/tally/income/export-details/${schoolId}?yearId=${academicYearId}`,
      { responseType: "blob" }
    );
    return response.data;
  }

  static async getClassFeeSummary(schoolId, academicYearId, classId, sectionId) {
    let path = `/api/admin/tally/fee-summary/${schoolId}`;
    if (classId !== undefined && classId !== null && classId !== '') path += `/${classId}`;
    if (sectionId !== undefined && sectionId !== null && sectionId !== '') path += `/${sectionId}`;
    return API.get(`${path}?yearId=${academicYearId}`);
  }

  static async exportClassFeeSummary(schoolId, academicYearId) {
    const response = await API.get(
      `/api/admin/tally/class-fee-summary/export/${schoolId}?yearId=${academicYearId}`,
      { responseType: "blob" }
    );
    return response.data;
  }

  // Delete Expense
  static async deleteExpense(expenseId) {
    try {
      const response = await API.delete(
        `/api/admin/tally/delete-expense/${expenseId}`
      );
      return response;
    } catch (error) {
      console.error('Error deleting expense:', error);
      throw error;
    }
  }
}

export default TallyService;